import styled from "styled-components";

export const ToastTitle = styled.span`
  margin-right: ${({ theme }): string => theme.spacing.unit(0.5)};
`;
